import { useSuspenseQuery } from '@tanstack/react-query';
import { clinicianGeneralGet } from '@actions';
import { useDispatch } from 'react-redux';
import { useSessionAppointmentId } from '@hooks/useSessionAppointmentId';

const useApptSuggestions = () => {
  const dispatch = useDispatch();
  const appt_id = useSessionAppointmentId(true);
  const {
    data: suggestionMeta,
    status: metaStatus,
    isLoading
  } = useSuspenseQuery({
    queryKey: ['meta/suggest/APPUSER', appt_id],
    queryFn: () => dispatch(clinicianGeneralGet(appt_id))
  });

  return { suggestionMeta, metaStatus, isLoadingSuggestions: isLoading };
};

export default useApptSuggestions;
